import styled from 'styled-components'
import { IconsQA } from 'shared/dataAttributes'

const Img = styled.img`
  height: auto;
  width: 80px;
`

const PayPalIcon = () => {
  return <Img src="/static/icons/paypal.png" data-qa={IconsQA.PaypalIcon} />
}

export default PayPalIcon
